<template>
  <div class="modal-header">
    <h4 class="modal-title" id="myLargeModalLabel">
      {{ aSinglePatient.lastName + " " + aSinglePatient.firstName }} -
      {{ aSinglePatient.dob }} - {{ propTarget.ptid }}
    </h4>
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="close">
      ×
    </button>
  </div>

  <div class="modal-body mb-1 pt-2">
    <div class="vtabs customvtab">
      <ul class="nav nav-tabs tabs-vertical" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            id="details_home"
            href="#home3"
            role="tab"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Details</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#customDemo3"
            role="tab"
            @click="GetPatientQuest()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Custom Demo</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#insuranceList3"
            role="tab"
            @click="GetPatientInsurance()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Insurance</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#paymentRequestList3"
            role="tab"
            @click="requestPaymentClick()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Payment Request</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#visitHistory3"
            role="tab"
            @click="GetVisitHistory()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Visit History</span></a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#paymentHistory3"
            role="tab"
            @click="GetPaymentHistory()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Payment History</span></a
          >
        </li>
        <!-- <li class="nav-item">
          <a
            id="emailHistory1221"
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#emailHistory"
            role="tab"
            @click="GetEmailHistory()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down"
              >Email History<span class="badge badge-danger mr-1"></span></span
          ></a>
        </li>
        <li class="nav-item">
          <a
            id="textHistory1221"
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#textHistory3"
            role="tab"
            @click="textHistoryClick()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down"
              >Text History<span class="badge badge-danger mr-1"></span></span
          ></a>
        </li> -->
        <!-- <li class="nav-item">
          <a
            class="nav-link text-nowrap"
            data-toggle="tab"
            style="border: none"
            href="#auditList3"
            role="tab"
            @click="GetAuditLog()"
            ><span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">History</span>
          </a>
        </li> -->
      </ul>
      <!-- Tab panes -->
      <div class="tab-content" style="width: 100%">
        <div class="tab-pane profile-tab-pane" id="home3" role="tabpanel">
          <button
            class="btn btn-outline-success waves-effect col-12"
            id="a1"
            @click="updateDetailsClickNew()"
          >
            Save
          </button>
          <div class="modal-body">
            <h3 class="font-weight-bold h3Spacing">Basic Details</h3>
            <form class="floating-labels">
              <!-- first row 77-->
              <div class="row">
                <div class="col-lg-6">
                  <!-- first name -->
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.firstName != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="firstName"
                        maxlength="50"
                        placeholder=""
                        v-model="aSinglePatient.firstName"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >First Name<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                  <!-- first name -->
                </div>
                <div class="col-lg-6">
                  <!-- last name -->
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.lastName != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="lastName"
                        placeholde=""
                        maxlength="50"
                        v-model="aSinglePatient.lastName"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Last Name<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                  <!-- last name -->
                </div>
              </div>
              <!-- first row -->

              <!-- second row *77*-->
              <div class="row">
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.dob != null ? '' : 'focused']"
                  >
                    <input
                      type="date"
                      class="form-control"
                      id="dob"
                      placeholder=""
                      v-model="aSinglePatient.dob"
                    /><span class="bar"></span>
                    <label
                      for=""
                      style="
                        margin-top: -31px;
                        font-weight: bold;
                        margin-left: 2px;
                      "
                      >Date of Birth<span style="color: red"> *</span></label
                    >
                  </div>
                </div>

                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.gender != null ? '' : 'focused']"
                  >
                    <select
                      class="form-control custom-select"
                      tabindex="1"
                      v-model="aSinglePatient.gender"
                    >
                      <option value="0">Choose a Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Others</option>
                    </select>
                    <label
                      for=""
                      style="
                        margin-top: -31px;
                        font-weight: bold;
                        margin-left: 2px;
                      "
                      >Gender<span style="color: red"> *</span></label
                    >
                  </div>
                </div>
              </div>
              <!-- second row -->

              <!-- fourth row -->
              <div class="row">
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[
                      aSinglePatient.externalId != null ? '' : 'focused',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="extrnalid"
                        placeholder=""
                        v-model="aSinglePatient.externalId"
                      /><span class="bar"></span>
                      <label for="" id="font1">External ID</label>
                    </span>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.ssn != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <InputText
                        v-mask="'###-##-####'"
                        type="tel"
                        class="form-control float-class"
                        id="ssns1"
                        placeholder=""
                        v-model="aSinglePatient.ssn"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Social Security Number<span style="color: red">
                          *</span
                        ></label
                      >
                    </span>
                  </div>
                </div>
              </div>
              <!-- fourth row -->

              <h3 class="font-weight-bold h3Spacing">Contact Information</h3>
              <!-- third row -->
              <div class="row">
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.phone.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="tel"
                        class="form-control float-class"
                        id="Phones1"
                        v-mask="'###-###-####'"
                        v-model="aSinglePatient.phone"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Phone Number<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.email.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="email"
                        class="form-control float-class"
                        id="emails1"
                        placeholder=""
                        maxlength="50"
                        v-model="aSinglePatient.email"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Email<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>
              </div>
              <!-- third row -->

              <h3 class="font-weight-bold h3Spacing">Address</h3>
              <!-- fifth row -->
              <div class="row">
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[
                      aSinglePatient.streetAddress != null ? '' : 'focused',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="streets1"
                        maxlength="100"
                        placeholder=""
                        v-model="aSinglePatient.streetAddress"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Street<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.city != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="citys1"
                        placeholder=""
                        maxlength="50"
                        v-model="aSinglePatient.city"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >City<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.zip != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="zips1"
                        maxlength="5"
                        placeholder=""
                        v-model="aSinglePatient.zip"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Zip<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.state != null ? '' : 'focused']"
                  >
                    <span class="p-float-label">
                      <select
                        class="form-control custom-select"
                        tabindex="1"
                        v-model="aSinglePatient.state"
                      >
                        <option value="">Choose State</option>
                        <option value="FL">FL</option>
                        <option value="AL">AL</option>
                        <option value="AK">AK</option>
                        <option value="AZ">AZ</option>
                        <option value="AR">AR</option>
                        <option value="CA">CA</option>
                        <option value="CO">CO</option>
                        <option value="CT">CT</option>
                        <option value="DE">DE</option>
                        <option value="GA">GA</option>
                        <option value="HI">HI</option>
                        <option value="ID">ID</option>
                        <option value="IL">IL</option>
                        <option value="IN">IN</option>
                        <option value="IA">IA</option>
                        <option value="KS">KS</option>
                        <option value="KY">KY</option>
                        <option value="ME">ME</option>
                        <option value="MD">MD</option>
                        <option value="MA">MA</option>
                        <option value="MI">MI</option>
                        <option value="MN">MN</option>
                        <option value="MS">MS</option>
                        <option value="MO">MO</option>
                        <option value="MT">MT</option>
                        <option value="NE">NE</option>
                        <option value="NV">NV</option>
                        <option value="NH">NH</option>
                        <option value="NJ">NJ</option>
                        <option value="NM">NM</option>
                        <option value="NY">NY</option>
                        <option value="NC">NC</option>
                        <option value="ND">ND</option>
                        <option value="OH">OH</option>
                        <option value="OK">OK</option>
                        <option value="OR">OR</option>
                        <option value="PA">PA</option>
                        <option value="RI">RI</option>
                        <option value="SC">SC</option>
                        <option value="SD">SD</option>
                        <option value="TN">TN</option>
                        <option value="TX">TX</option>
                        <option value="UT">UT</option>
                        <option value="VT">VT</option>
                        <option value="VA">VA</option>
                        <option value="WA">WA</option>
                        <option value="WV">WV</option>
                        <option value="WI">WI</option>
                        <option value="WY">WY</option>
                      </select>
                      <label for="" id="font1" style="margin-top: -31px"
                        >State<span style="color: red"> *</span></label
                      >
                    </span>
                  </div>
                </div>
              </div>
              <!-- fifth row -->
            </form>
          </div>
        </div>
        <div class="tab-pane profile-tab-pane" id="customDemo3" role="tabpanel">
          <!-- <button
              class="btn btn-outline-success waves-effect col-12"
              id="a2"
              @click="demoSaveClick"
            >
              Save
            </button> -->
          <div class="modal-body">
            <form>
              <div class="row" v-for="(quest, ndx07) in visitDemo" :key="ndx07">
                <!--  TEXT  -->
                <div class="col-12" v-if="quest.questionInputTypeId == 1">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">
                      {{ quest.question }}
                    </p>
                  </div>
                  <fieldset class="floating-labels">
                    <div class="form-group m-b-40" style="margin-top: -18px">
                      <input
                        type="text"
                        class="form-control required"
                        id=""
                        placeholder=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                    </div>
                  </fieldset>
                </div>
                <!--  END TEXT  -->
                <!--  CHECK BOX  -->
                <div
                  class="col-12 m-b-40"
                  v-if="quest.questionInputTypeId === 2"
                >
                  <fieldset class="floating-labels">
                    <div
                      class="input-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">
                        {{ quest.question }}
                      </p>
                    </div>
                  </fieldset>
                  <div class="input-group">
                    <div
                      class="row"
                      v-for="(opt, ndxA1) in quest.options"
                      :key="ndxA1"
                    >
                      <div style="margin-right: 100px">
                        <input
                          class="input1"
                          type="checkbox"
                          value="3"
                          name="checkbox"
                          id=""
                        />
                        <label
                          v-if="opt.questOptionId == quest.answer"
                          style="background-color: #00bfff"
                          for="checkbox1"
                          @click="questOptionSelected(quest, opt)"
                          class="btn"
                          >{{ opt.questOption }}</label
                        >
                        <label
                          v-else
                          for="checkbox1"
                          @click="questOptionSelected(quest, opt)"
                          class="btn btn-outline-info label2"
                          >{{ opt.questOption }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END CHECK BOX  -->

                <!--  RATING  -->
                <div
                  class="col-6 m-b-40"
                  v-if="quest.questionInputTypeId === 3"
                >
                  <div class="form-group">
                    <p class="boldText">{{ quest.question }}</p>
                    <div class="input-group">
                      <div class="floating-labels">
                        <div class="row">
                          <div
                            class="form-group col-1 m-r-40"
                            v-for="(opt, ndxA1) in quest.options"
                            :key="ndxA1"
                          >
                            <input
                              class="input1"
                              type="radio"
                              value="1"
                              name="radio"
                              id="radio1"
                            />
                            <label
                              v-if="opt.questOptionId == quest.answer"
                              style="background-color: #00bfff"
                              for="radio1"
                              class="btn label1"
                              data-toggle="tooltip"
                              data-placement="top"
                              :title="opt.questOption"
                              @click="questOptionSelected(quest, opt)"
                              :class="
                                opt.questOptionId == quest.answer
                                  ? 'btn btn-info label1'
                                  : 'btn btn-outline-info label1'
                              "
                              >O{{ ndxA1 + 1 }}</label
                            >
                            <label
                              v-else
                              for="radio1"
                              class="btn btn-outline-info label1"
                              data-toggle="tooltip"
                              data-placement="top"
                              :title="opt.questOption"
                              @click="questOptionSelected(quest, opt)"
                              >O{{ ndxA1 + 1 }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END RATING  -->

                <!--  RADIO BUTTON  -->
                <div
                  class="col-6 m-b-40"
                  v-if="quest.questionInputTypeId === 4"
                >
                  <fieldset class="floating-labels">
                    <div
                      class="form-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">
                        {{ quest.question }}
                      </p>
                    </div>
                  </fieldset>
                  <div class="input-group">
                    <div class="row">
                      <div
                        style="margin-right: 100px"
                        v-for="(opt, ndxA1) in quest.options"
                        :key="ndxA1"
                      >
                        <input
                          class="input1"
                          type="radio"
                          value="1"
                          name="radio"
                          id="radio1"
                        />
                        <label
                          v-if="opt.questOptionId == quest.answer"
                          style="background-color: #00bfff; color: black"
                          for="radio1"
                          class="btn btn-outline-info label2"
                          @click="questOptionSelected(quest, opt)"
                          >{{ opt.questOption }}</label
                        >
                        <label
                          v-else
                          for="radio1"
                          class="btn btn-outline-info label2"
                          @click="questOptionSelected(quest, opt)"
                          >{{ opt.questOption }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END RADIO BUTTON  -->

                <!--  EMAIL  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 5">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">
                        {{ quest.question }}
                      </p>
                    </div>
                    <div class="form-group m-b-40" style="margin-top: -18px">
                      <input
                        type="text"
                        class="form-control required"
                        id=""
                        placeholder=""
                        maxlength="50"
                        v-model="quest.answer"
                      /><span class="bar"></span>
                    </div>
                  </fieldset>
                </div>
                <!--  END EMAIL  -->

                <!--  PHONE  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 6">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group m-b-40"
                      :class="[quest.question != null ? 'focused' : '']"
                    >
                      <input
                        type="tel"
                        class="form-control required phone-inputmask"
                        id=""
                        placeholder=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                      <label for="street">{{ quest.question }}</label>
                    </div>
                  </fieldset>
                </div>

                <!--  DATE  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 7">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">{{ quest.question }}</p>
                    </div>
                    <div class="form-group" style="margin-top: -18px">
                      <input
                        type="date"
                        class="form-control"
                        id=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                    </div>
                  </fieldset>
                </div>
                <!--  END DATE  -->
              </div>
            </form>
          </div>
        </div>
        <div
          class="tab-pane profile-tab-pane"
          id="insuranceList3"
          role="tabpanel"
        >
        <!-- thi  -->
          <button
            :disabled="updButton == 0"
            class="btn btn-outline-success waves-effect col-12"
            @click="saveInsuranceClick()"
          >
            Save
          </button>
          <div class="modal-body">
            <h3 class="font-weight-bold h3Spacing">Primary Insurance</h3>
            <form class="floating-labels">
              <!-- first row -->
              <div class="row">
                <div class="col-lg-6">
                  <!-- Primary Insurance -->
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[
                      (insurance.primaryInsurance + '').length > 0
                        ? 'focused'
                        : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="pinsur"
                        placeholder=""
                        maxlength="100"
                        v-model="insurance.primaryInsurance"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Primary Insurance<span style="color: red"> *</span>
                      </label>
                    </span>
                  </div>
                  <!-- Primary Insurance -->
                </div>
                <div
                  class="col-lg-6"
                  v-bind:class="[
                    (insurance.primaryInsuranceNo + '').length > 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <!-- Primary Insurance Number -->
                  <div class="form-group m-b-40">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="pinsNo"
                        placeholder=""
                        maxlength="50"
                        v-model="insurance.primaryInsuranceNo"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Primary Insurance Number<span style="color: red">
                          *</span
                        ></label
                      >
                    </span>
                  </div>
                  <!-- Primary Insurance Number -->
                </div>
                <div class="col-lg-6">
                  <!-- Primary Insurance Group ID -->
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[
                      insurance.primaryInsuranceGroupId.length > 0
                        ? 'focused'
                        : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="insG"
                        placeholder=""
                        maxlength="50"
                        v-model="insurance.primaryInsuranceGroupId"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Primary Insurance Group ID<span style="color: red">
                          *</span
                        ></label
                      >
                    </span>
                  </div>
                  <!-- Primary Insurance Group ID -->
                </div>
                <div class="col-lg-6">
                  <!-- Insurance ID -->
                  <div class="form-group m-b-40">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLang_f"
                    />
                    <label
                      class="custom-file-label"
                      id="customFileLang_fl"
                      for="customFileLang"
                    >
                      {{ insurance.primaryInsuranceId }}
                    </label>
                  </div>
                  <!-- Insurance ID -->
                </div>
              </div>
              <!-- first row -->
            </form>

            <h3 class="font-weight-bold h3Spacing">Secondary Insurance</h3>
            <form class="floating-labels">
              <!-- first row -->
              <div class="row">
                <div class="col-lg-6">
                  <!-- Secondary Insurance -->
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[
                      (insurance.secondaryInsurance + '').length > 0
                        ? 'focused'
                        : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="Sinsurance"
                        placeholder=""
                        maxlength="100"
                        v-model="insurance.secondaryInsurance"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Secondary Insurance<span style="color: red"> *</span>
                      </label>
                    </span>
                  </div>
                  <!-- Secondary Insurance -->
                </div>
                <div
                  class="col-lg-6"
                  v-bind:class="[
                    (insurance.secondaryInsuranceNo + '').length > 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <!-- Secondary Insurance Number -->
                  <div class="form-group m-b-40">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        aria-labelledby="inuranceNo"
                        placeholder=""
                        maxlength="50"
                        v-model="insurance.secondaryInsuranceNo"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Secondary Insurance Number<span style="color: red">
                          *</span
                        ></label
                      >
                    </span>
                  </div>
                  <!-- Secondary Insurance Number -->
                </div>
                <div class="col-lg-6">
                  <!-- Secondary Insurance Group ID -->
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[
                      insurance.secondaryInsuranceGroupId.length > 0
                        ? 'focused'
                        : '',
                    ]"
                  >
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        class="form-control float-class"
                        id="SinsuG"
                        placeholder=""
                        maxlength="50"
                        v-model="insurance.secondaryInsuranceGroupId"
                      /><span class="bar"></span>
                      <label for="" id="font1"
                        >Secondary Insurance Group ID<span style="color: red">
                          *</span
                        ></label
                      >
                    </span>
                  </div>
                  <!-- Secondary Insurance Group ID -->
                </div>
                <div class="col-lg-6">
                  <!-- Insurance ID -->
                  <div class="form-group m-b-40">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLang_s"
                      v:bind=""
                    />
                    <label
                      class="custom-file-label"
                      for="customFileLang_s"
                      id="customFileLang_sl"
                    >
                      {{ insurance.secondaryInsuranceId }}
                    </label>
                  </div>
                  <!-- Insurance ID -->
                </div>
              </div>
              <!-- first row -->
            </form>
          </div>
        </div>
        <div
          class="tab-pane profile-tab-pane"
          id="paymentRequestList3"
          role="tabpanel"
        >
          <div class="row justify-content-end">
            <div class="col-sm-4">
              <input
                style="margin-bottom: 6px; margin-left: 51px"
                type="text"
                name="daterange"
                :value="initDate_1"
                @change="datePicker"
                @focus="datePicker"
              />
              <div class="input-group-append">
                <span
                  class="input-group-text"
                  style="
                    position: absolute;
                    margin-top: -34px;
                    margin-left: 230px;
                  "
                >
                  <span class="ti-calendar"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table
              data-height="300"
              data-width="100%"
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
            >
              <thead class="thead-dark">
                <tr>
                  <th>Full Name</th>
                  <th>Date of Service</th>
                  <th>Date Requested</th>
                  <th>Sent To</th>
                  <th>Amount Requested</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(rp, ndxA04) in allFilterPatients_1" :key="ndxA04">
                  <td>
                    <div v-if="updButton == 1" class="btn-group">
                      <button
                        type="button"
                        :disabled="rp.status == '4'"
                        :class="collectPaymentButtonClass(rp)"
                        @click="collectPayment(rp)"
                      >
                        Collect Payment
                      </button>
                      <button
                        type="button"
                        :class="collectPaymentButtonClassDropDown(rp)"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        :disabled="rp.status == '4'"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          @click="GetPaymentInfo(rp)"
                          data-target="#reminder"
                          >Reminder</a
                        >
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="deletePaymentRequestClick(rp)"
                          id="delete_request"
                          >Delete</a
                        >
                      </div>
                    </div>
                    <div v-else class="btn-group">
                      <button
                        type="button"
                        :disabled="updButton == 0"
                        :class="collectPaymentButtonClass(rp)"
                        @click="collectPayment(rp)"
                      >
                        Collect Payment
                      </button>
                      <button
                        type="button"
                        :class="collectPaymentButtonClassDropDown(rp)"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        :disabled="updButton == 0"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          @click="GetPaymentInfo(rp)"
                          data-target="#reminder"
                          >Reminder</a
                        >
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="deletePaymentRequestClick(rp)"
                          id="delete_request"
                          >Delete</a
                        >
                      </div>
                    </div>
                  </td>
                  <td>{{ rp.dosStr }}</td>
                  <td>{{ rp.billDateDate }}</td>
                  <td>
                    <div>
                      <span class="bs-label label-success badgeBorder">
                        <a
                          href="/cdn-cgi/l/email-protection"
                          class="__cf_email__"
                          data-cfemail="3546545b4654475c07755258545c591b565a58"
                          >[email&#160;protected]</a
                        >
                      </span>
                    </div>
                    <br />
                    <div>
                      <span class="bs-label label-success badgeBorder">
                        {{ rp.phone }}
                      </span>
                    </div>
                  </td>
                  <td>{{ rp.amount }}$</td>
                  <td>
                    <div class="form-group">
                      <select class="form-control" v-model="rp.inputStatus">
                        <option
                          v-for="(pymnt, ndx05) in paymentStatus"
                          :key="ndx05"
                          :value="pymnt.PValue"
                        >
                          {{ pymnt.text }}
                        </option>
                        <!-- <option value="Sent">Sent</option>
                                <option value="Pending">Pending</option>
                                <option value="Disputed">Disputed</option>
                                <option value="Paid">Paid</option> -->
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="tab-pane"
          id="visitHistory3"
          role="tabpanel"
          style="overflow: hidden"
        >
          <div class="row justify-content-end">
            <div class="col-sm-4" style="left: -30px !important">
              <div class="input-group mb-3">
                <div class="col-sm-4">
                  <input
                    style="margin-bottom: 6px; margin-left: 51px"
                    type="text"
                    name="daterange"
                    :value="initDate"
                    @change="datePicker_1"
                    @focus="datePicker_1"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="
                        position: absolute;
                        margin-top: -34px;
                        margin-left: 230px;
                      "
                    >
                      <span class="ti-calendar"></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" style="width: 933px">
            <div
              class="table-responsive"
              style="width: 95% !important; overflow-x: scroll !important "
            >
              <table
                id="visitm"
                class="table display table-bordered table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Visit Type</th>
                    <th>Reason</th>
                    <th>DOS</th>
                    <th>Time In</th>
                    <th>Stage</th>
                    <th>Step</th>
                    <th>Physician</th>
                    <th>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vhis, ndx04) in allFilterVisitHist" :key="ndx04">
                    <td>{{ vhis.visitTypeName }}</td>
                    <td>{{ vhis.reason }}</td>
                    <td>{{ vhis.dosLocalDateStr }}</td>
                    <td>{{ vhis.dosLocalTimeStr }}</td>
                    <td>{{ vhis.stageName }}</td>
                    <td>{{ vhis.stepName }}</td>
                    <td>{{ vhis.physicianName }}</td>
                    <td>{{ vhis.commentText }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Payment Received -->
        <div
          class="tab-pane profile-tab-pane"
          id="paymentHistory3"
          role="tabpanel"
          style="overflow: hidden"
        >
          <div class="row justify-content-end">
            <div class="col-sm-4" style="left: -25px !important">
              <div class="input-group mb-3">
                <div class="col-sm-4">
                  <input
                    style="margin-bottom: 6px; margin-left: 51px"
                    type="text"
                    name="daterange"
                    :value="initDate_2"
                    @change="datePicker_2"
                    @focus="datePicker_2"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="
                        position: absolute;
                        margin-top: -34px;
                        margin-left: 230px;
                      "
                    >
                      <span class="ti-calendar"></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body" style="width: 933px">
            <div class="table-responsive">
              <table
                id="config-table6"
                class="table display table-bordered table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>DOS</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Comment</th>
                    <th>Stage</th>
                    <th>Collection Date</th>
                    <th>Collected By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ph, ndx04) in allFilterPayHist" :key="ndx04">
                    <td>{{ ph.dosStr }}</td>
                    <td>{{ ph.amount }}</td>
                    <td>{{ ph.statusStr }}</td>
                    <td>{{ ph.comment }}</td>
                    <td>{{ ph.paymentMethodStr }}</td>
                    <td>{{ ph.paymentDateStr }}</td>
                    <td>{{ ph.collectedByName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          class="tab-pane profile-tab-paneV2"
          id="emailHistory"
          role="tabpanel"
        >
          <div class="tab-content">
            <div
              class="tab-pane active"
              id="inBoxv3"
              role="tabpanel"
              style="width: 1100px !important"
            >
              <form class="">
                <div class="col-10 bg-light">
                  <a
                    href=""
                    data-toggle="modal"
                    data-target="#sendEmail"
                    class="
                      btn btn-danger
                      m-b-20
                      p-10
                      btn-block
                      waves-effect waves-light
                    "
                    @click="sendEmailClick()"
                    >Compose</a
                  >
                  <div class="card-body p-t-0">
                    <div class="card b-all shadow-none">
                      <div class="inbox-center table-responsive">
                        <table class="table table-hover no-wrap">
                          <tbody>
                            <tr
                              v-for="(emailHis, ndx01) in emailHistory"
                              :key="ndx01"
                              class=""
                            >
                            <td> {{ndx01 + 1}})</td>
                              <td style="width: 40px">
                                <div
                                  class="custom-control custom-checkbox mr-sm-2"
                                >
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="checkbox0"
                                    value="check"
                                  />
                                  <!-- <label
                                    class="custom-control-label"
                                    for="checkbox0"
                                  ></label> -->
                                </div>
                              </td>
                              <td style="width: 40px" class="hidden-xs-down">
                                <!-- <i class="far fa-star"></i> -->
                              </td>
                              <td class="hidden-xs-down">
                                {{ emailHisUser }}
                              </td>
                              <td class="max-texts">
                                <a
                                  href="javascript:void(0)"
                                  @click="
                                    getEmailInfor(
                                      emailHis.messageShort,
                                      emailHis.message,
                                      emailHis.emailTo,
                                      emailHis.subject
                                    )
                                  "
                                  class="nav-link"
                                  >{{ emailHis.subject }}</a
                                >
                              </td>
                              <!-- <td class="hidden-xs-down">
                                <a
                                  @click="
                                    getEmailInfor(
                                      emailHis.messageShort,
                                      emailHis.message,
                                      emailHis.emailTo,
                                      emailHis.subject
                                    )
                                  "
                                > -->
                                <!-- </a>
                              </td> -->

                              <td class="text-right">
                                {{ emailHis.emailDateStr }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          class="tab-pane profile-tab-pane"
          id="textHistory3"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-10">
              <div class="card m-b-0">
                <!-- .chat-row -->
                <div class="chat-main-box" style="width: 920px !important">
                  <!-- .chat-left-panel -->
                  <div class="chat-left-aside">
                    <a
                      href=""
                      data-toggle="modal"
                      data-target="#sendText"
                      class="
                        btn btn-info
                        m-b-20
                        p-10
                        btn-block
                        waves-effect waves-light
                      "
                      @click="sendTextClick()"
                      >Compose</a
                    >
                    <div class="open-panel">
                      <i class="ti-angle-right"></i>
                    </div>
                    <div class="chat-left-inner">
                      <div class="form-material">
                       <input
                        class="form-control p-2"
                        v-model="TextSearch"
                        type="text"
                        placeholder="Search Contact"
                       />
                      </div>
                      <div
                          class="list-group text-left"
                          id="list-tab"
                          role="tablist"
                          >
                           <a
                           v-for="(user, ndx00B) in filterTextSearch"
                           :key="ndx00B"
                           @click="smsContactClick(user)"
                           :class="clickSmsLis(user)"
                          role="tab"
                          aria-selected="true"
                          ><i></i
                          >{{ user.name }}</a
                        >
                       </div>
                    </div>
                  </div>

                  <!-- .chat-right-panel -->
                  <div class="chat-right-aside">
                    <div class="chat-main-header">
                      <div class="p-3 b-b">
                        <h4 class="box-title">Chat Message</h4>
                      </div>
                    </div>
                    <div class="chat-rbox">
                      <ul class="chat-list p-3">
                        <!--chat Row -->
                        <li v-for="(sh, ndx00B1) in textHistory" :key="ndx00B1">
                          <div class="chat-content">
                            <h5 class="font-weight-bolder">
                              {{
                                sh.fromName 
                              }}
                            </h5>
                            <div class="box bg-light-info">
                              {{ sh.message }}
                            </div>
                            <div id="chat" class="chat-time">
                              {{ sh.messageDate + " " + sh.messageTime}}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body border-top">
                      <div class="row">
                        <div class="col-8">
                          <textarea
                            v-model="chatSms"
                            placeholder="Type your message here"
                            class="form-control border-0"
                          ></textarea>
                        </div>
                        <div class="col-4 text-right">
                          <button
                            type="button"
                            @click="chatSmsSent()"
                            class="btn btn-info btn-circle btn-lg"
                          >
                            <i class="fas fa-paper-plane"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- .chat-right-panel -->
                </div>
                <!-- /.chat-row -->
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane profile-tab-pane" id="auditList3" role="tabpanel">
          <div class="row" v-for="(act, ndx) in auditData" :key="ndx">
            <div
              class="col-12"
              v-for="(dt, ndx01) in act.actionDates"
              :key="ndx01"
            >
              <div class="card">
                <div class="card-body">
                  <ul class="timeline">
                    <li
                      v-for="(actType, ndx02) in dt.actionTypes"
                      :key="ndx02"
                      :class="ndx01 % 2 == 0 ? '' : 'timeline-inverted'"
                    >
                      <div class="timeline-badge warning">
                        <img
                          :src="getIcon(actType.actionTypeId)"
                          alt=""
                          style="height: 20px; margin: 16px"
                        />
                      </div>
                      <div class="timeline-panel">
                        <div class="row">
                          <div class="col-8">
                            <div class="timeline-heading">
                              <p
                                class="timeline-title"
                                style="font-size: 20px; font-weight: 800"
                              >
                                {{ actType.actionTypeName }} <br /><small
                                  class="text-muted"
                                  >{{ actType.appModelName }}</small
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-4">
                            <h4 class="timeline-title">
                              {{ act.actionToName }}
                            </h4>
                            <p>
                              <small class="text-muted">
                                <i class="fa fa-clock-o"></i
                                >{{ dateToLocalString(dt.actionDate) }}
                              </small>
                            </p>
                          </div>
                        </div>
                        <div class="timeline-body">
                          <p
                            v-for="(msg, ndx03) in actType.actionMessages"
                            :key="ndx03"
                          >
                            {{ msg }}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    id="emailDetails"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="row">
                    <div class="card-body p-t-0">
                      <div class="card b-all shadow-none">
                        <div class="card-body">
                          <h3 class="card-title m-b-0">
                            {{ subject }}
                          </h3>
                        </div>
                        <div>
                          <hr class="m-t-0" />
                        </div>
                        <div class="card-body">
                          <div class="d-flex m-b-40">
                            <div>
                              <!-- <a
                                class="
                                  nav-link
                                  dropdown-toggle
                                  waves-effect waves-dark
                                  profile-pic
                                "
                                href=""
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              > -->
                                <img
                                  v-if="Image == ''"
                                  style="
                                    border-radius: 50%;
                                    height: 40px;
                                    width: 40px;
                                  "
                                  src="assets/images/profile.jpg"
                                  class="" />
                                <img
                                  v-else
                                  :src="Image"
                                  alt=""
                                  class=""
                                  style="
                                    border-radius: 50%;
                                    height: 40px;
                                    width: 40px;
                                  "
                              />
                            </div>
                            <div class="p-l-10">
                              <h4 class="m-b-0">
                                {{
                                  aSinglePatient.firstName +
                                  " " +
                                  aSinglePatient.lastName
                                }}
                              </h4>
                              <small class="text-muted"
                                >to:
                                <span
                                  class="__cf_email__"
                                  data-cfemail="e58f8a8b84918d848ba5818a88848c8bcb868a88"
                                >
                                  {{ emailTo }}</span
                                ></small
                              >
                            </div>
                          </div>
                        <p><b>Dear User</b></p>
                        <p v-html="emailMessage"> </p>
                        </div>
                        <div>
                          <hr class="m-t-0" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- paymentMethod v2-->
  <div
    class="modal bs-example-modal-lg fade"
    id="paymentMethodv2"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Select A Payment Method</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row text-center">
              <div class="col m-2 p-2">
                <a href="" data-target="#debit" data-toggle="modal">
                  <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
                  <h4 class="font-weight-bold">Credit Or Debit Card</h4>
                </a>
              </div>

              <div class="col m-2 p-2">
                <a href="" data-target="#cash" data-toggle="modal">
                  <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
                  <h4 class="font-weight-bold">Cash</h4>
                </a>
              </div>

              <div class="col m-2 p-2">
                <a href="" data-target="#cheque" data-toggle="modal">
                  <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
                  <h4 class="font-weight-bold">Cheque</h4>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- paymentMethod v2-->

  <!-- Payment Authorize Credit -->
  <div
    id="debit"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Payment Via Authorize</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <h4 class="font-weight-bold h4-responsive">
            Payment Verfication will be Done
          </h4>
          <form class="floating-labels m-t-40">
            <div
              class="form-group m-b-40"
              :class="[
                aSinglePaymentReceived.holderName != null ? 'focused' : '',
              ]"
            >
              <input
                type="text"
                class="form-control"
                id=""
                maxlength="30"
                v-model="aSinglePaymentReceived.holderName"
              /><span class="bar"></span>
              <label for=""
                >Card Holder Name<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group m-b-40"
              :class="[
                aSinglePaymentReceived.tdNumber != null ? 'focused' : '',
              ]"
            >
              <input
                v-mask="'####-####-####-####'"
                type="tel"
                class="form-control"
                id=""
                v-model="aSinglePaymentReceived.tdNumber"
              /><span class="bar"></span>
              <label for=""
                >Card Number<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group m-b-40"
              :class="[aSinglePaymentReceived.cardCVC != null ? 'focused' : '']"
            >
              <input
                v-mask="'######'"
                type="tel"
                class="form-control"
                id=""
                v-model="aSinglePaymentReceived.cardCVC"
              /><span class="bar"></span>
              <label for="">Card CVC<span style="color: red"> *</span></label>
            </div>
            <div
              class="form-group m-b-40"
              :class="[aSinglePaymentReceived.zip != null ? 'focused' : '']"
            >
              <input
                type="text"
                class="form-control"
                id=""
                maxlength="8"
                v-model="aSinglePaymentReceived.zip"
              /><span class="bar"></span>
              <label for="zip">Zip<span style="color: red"> *</span></label>
            </div>
            <div
              class="form-group m-b-40"
              :class="[aSinglePaymentReceived.amount != null ? 'focused' : '']"
            >
              <input
                type="number"
                class="form-control"
                id=""
                @keypress="isNumber($event)"
                v-model="aSinglePaymentReceived.amount"
              /><span class="bar"></span>
              <label for="">Amount<span style="color: red"> *</span></label>
            </div>
            <div
              class="form-group"
              :class="[aSinglePaymentReceived.comment != null ? 'focused' : '']"
            >
              <label for="" class="control-label"
                >Comment<span style="color: red"> *</span>:</label
              >
              <textarea
                class="form-control"
                id=""
                maxlength="255"
                v-model="aSinglePaymentReceived.comment"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-success waves-effect waves-light col-12"
            id="creditCardPayment"
            @click="paymentReceivedClick('credit-card')"
          >
            Process
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Payment Authorize Credit  -->

  <!-- Payment Authorize Cash -->
  <div
    id="cash"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Cash On The Spot</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form class="floating-labels m-t-40">
            <div
              class="form-group m-b-40"
              v-bind:class="[
                aSinglePaymentReceived.amount != null ? 'focused' : '',
              ]"
            >
              <input
                type="number"
                class="form-control"
                id=""
                @keypress="isNumber($event)"
                v-model="aSinglePaymentReceived.amount"
              /><span class="bar"></span>
              <label for=""
                >Amount(In $)<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group"
              v-bind:class="[
                aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
              ]"
            >
              <label for="" class="control-label"
                >Comment<span style="color: red"> *</span>:</label
              >
              <textarea
                class="form-control"
                id=""
                maxlength="255"
                v-model="aSinglePaymentReceived.comment"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-success waves-effect waves-light col-12"
            id="cashPayment"
            @click="paymentReceivedClick('cash')"
          >
            Collect
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Payment Authorize Cash  -->

  <!-- Payment Authorize cheque -->
  <div
    id="cheque"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Payment Via Cheque</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form class="floating-labels m-t-40">
            <div
              class="form-group m-b-40"
              v-bind:class="[
                aSinglePaymentReceived.tdNumber.length > 0 ? 'focused' : '',
              ]"
            >
              <input
                v-mask="'####-####-####-####'"
                type="tel"
                class="form-control"
                id=""
                v-model="aSinglePaymentReceived.tdNumber"
              /><span class="bar"></span>
              <label for=""
                >Cheque Number<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group m-b-40"
              v-bind:class="[
                aSinglePaymentReceived.amount != null ? 'focused' : '',
              ]"
            >
              <input
                type="number"
                class="form-control"
                id=""
                @keypress="isNumber($event)"
                v-model="aSinglePaymentReceived.amount"
              /><span class="bar"></span>
              <label for=""
                >Amount(In $)<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group m-b-40"
              v-bind:class="[
                aSinglePaymentReceived.holderName.length > 0 ? 'focused' : '',
              ]"
            >
              <input
                type="text"
                class="form-control"
                id=""
                maxlength="100"
                v-model="aSinglePaymentReceived.holderName"
              /><span class="bar"></span>
              <label for=""
                >Cheque Holder Name<span style="color: red"> *</span></label
              >
            </div>
            <div
              class="form-group"
              v-bind:class="[
                aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
              ]"
            >
              <label for="" class="control-label"
                >Comment<span style="color: red"> *</span>:</label
              >
              <textarea
                class="form-control"
                id=""
                maxlength="255"
                v-model="aSinglePaymentReceived.comment"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-success waves-effect waves-light col-12"
            id="chequePayment"
            @click="paymentReceivedClick('cheque')"
          >
            Collect
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Payment Authorize cheque  -->

  <!-- Reminder -->
  <div
    id="reminder"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Reminder</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form class="floating-labels m-t-40">
            <div
              class="form-group m-b-40"
              v-bind:class="[aSinglePayment.email != null ? 'focused' : '']"
            >
              <input
                type="text"
                v-model="aSinglePayment.email"
                class="form-control"
                id=""
              /><span class="bar"></span>
              <label for="">Email<span style="color: red"> *</span></label>
            </div>
            <div
              class="form-group m-b-40"
              v-bind:class="[aSinglePayment.phone != null ? 'focused' : '']"
            >
              <input
                v-mask="'###-###-####'"
                type="tel"
                v-model="aSinglePayment.phone"
                class="form-control"
                id=""
              /><span class="bar"></span>
              <label for=""
                >Phone Number<span style="color: red"> *</span></label
              >
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            @click="sendReminderClick"
            class="btn btn-success waves-effect waves-light"
          >
            Send
          </button>
          <button
            type="button"
            class="btn btn-danger waves-effect waves-light"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Reminder -->

  <!-- Compose Email Modal -->
  <div
    class="modal bs-example-modal-lg fade"
    id="sendEmail"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Mailbox</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="col-8 col-md-8">
          <form class="">
            <div class="card-body">
              <h3 class="card-title">Compose New Message</h3>
              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="Template Name:"
                  maxlength="40"
                  v-model="aSingleEmail.name"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="Send:"
                  maxlength="100"
                  v-model="aSinglePatient.email"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="Subject:"
                  maxlength="100"
                  v-model="aSingleEmail.emailSubject"
                />
              </div>
              <Editor
                v-model="aSingleEmail.emailText"
                editorStyle="height: 200px"
              />
              <!-- <h4><i class="ti-link"></i> Attachment</h4> -->
              <!-- <form action="#" class="dropzone">
                        <div class="fallback">
                          <input name="file" type="file" multiple />
                        </div>
                      </form> -->
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            @click="sendEmail()"
            type="button"
            id="a3"
            class="btn btn-outline-success waves-effect waves-light col-12"
          >
            Send Email
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- SendText Modal -->
  <div
    class="modal bs-example-modal-lg fade"
    id="sendText"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Send a text</h4>
          <button type="button" class="close" @click="sendTextModalClose">
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col-4 col-md-4">
                <div class="row">
                  <div class="col-xl">
                    <div
                      class="list-group text-left"
                      id="list-tab"
                      role="tablist"
                    >
                      <a
                        style="word-break: break-all"
                        v-for="(sms, ndxA02) in smsTempsList"
                        :key="ndxA02"
                        @click="smsTempsListClick(sms)"
                        :class="selectedSmsTempClass(sms)"
                        id="list-home-list"
                        data-toggle="list"
                        href="#list-home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        ><i :class="selectedSmsTempIcon(sms)"></i>
                        {{ sms.name }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8 col-md-8">
                <form class="floating-labels m-t-40">
                  <div
                    class="form-group m-b-40"
                    :class="[aSingleSms.name.length > 0 ? 'focused' : '']"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="templateName"
                      maxlength="40"
                      v-model="aSingleSms.name"
                    /><span class="bar"></span>
                    <label for="templateName">Template Name</label>
                  </div>
                  <div
                    class="form-group m-b-40"
                    :class="[aSinglePatient.phone != null ? 'focused' : '']"
                  >
                    <input
                      v-mask="'###-###-####'"
                      type="tel"
                      class="form-control"
                      id="to"
                      v-model="aSinglePatient.phone"
                    /><span class="bar"></span>
                    <label for="to">To</label>
                  </div>
                  <div
                    class="form-group m-b-40"
                    :class="[aSingleSms.smsText.length > 0 ? 'focused' : '']"
                  >
                    <label for="comment-text" class="control-label"
                      >Type your text</label
                    >
                    <textarea
                      v-model="aSingleSms.smsText"
                      class="form-control"
                      id="comment-text"
                    ></textarea>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-success waves-effect waves-light col-12"
            id="a6"
            @click="SendSms()"
          >
            Send Text
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Send a Text Modal -->
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
export default {
  name: "PatientPortal",
  //components: {DateRangePicker},
  data() {
    return {
      emailTo: "",
      subject: "",
      emailHisUser: "",
      messageDate_1:{},
      updButton: 1,
      delButton: 1,
      collectPayButt: 1,
      Image: "",
      //loader
      loader: "",
      startDate: "",
      endDate: "",
      startDate_1: "",
      endDate_1: "",
      allFilterPatients_1: [],
      allFilterVisitHist: [],
      allPatients: [],
      allInsurances: [],
      suggestedPatients: [],
      allRawPatients: [],
      allFilterPatients: [],
      allFilterPayHist: [],
      auditData: [],
      initDate_1: "",
      initDate: "",
      initDate_2: "",
      startDate_2: "",
      endDate_2: "",
      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      aSelectedPatient: "",
      aSelectedInsurance: "",
      filterFirstName: "",
      filterLastName: "",
      filterPhone: "",
      filterDate: "",
      // actives
      aSingleStage: "",
      activeStageNdx: -1,
      activeStep: -1,
      aSinglePatient: {
        email: "",
        phone: "",
        insurance: {
          primaryInsurance: "",
          primaryInsuranceId: "Insurance Id",
          primaryInsuranceGroupId: "",
          secondaryInsurance: "",
          secondaryInsuranceId: "Secondary Id",
          secondaryInsuranceGroupId: "",
          primaryFilePath: "",
          secondaryFilePath: "",
        },
      },
      insurance: {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
        primaryFilePath: "",
        secondaryFilePath: "",
      },
      userTexts: [],
      emailHistory: [],
      aSingleUserSmsHist: [],
      paymentHistory: [],
      requestPaymentsList: [],
      smsTempsList: [],
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      //SMS Send
      aSingleSms: {
        name: "",
        smsText: "",
      },
      chatSms: "",
      //Email Object Used to send Emails
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },
      // a Single request payment
      aSinglePayment: "",
      aSingleRequestPayment: {
        patientId: 0,
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      //payment status Text update list
      paymentStatus: [
        { text: "Sent", PValue: 1 },
        { text: "Pending", PValue: 2 },
        { text: "Disputed", PValue: 3 },
        { text: "Paid", PValue: 4 },
      ],
      visitQuests: [],
      visitDemo: [],
      textHistory: [],
      textHistorySerch: [],
      visitHistory: [],
      users: [],
      //-- Search
      mainSearch: {
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        searchDate: "",
      },
      //Timer
        TimerObject: {},
    }; // return
  }, // data
  props: ["propTarget"],
  // ~~methods
  methods: {
    close(){
    this.$emit('destroyProp')
},
//Get Text
    async textHistoryClick() {
       this.aSingleText= {
        userId: ""
      }
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTextHistoryByVisitId";
      this.intDummyComm();
      this.dummyComm.visitId = this.propTarget.visitId;
      this.textHistory = await this.mixinsAxiosGetData(url, this.dummyComm);
      //set Time(textHistory)
       for(let j=0;j<this.textHistory.length;j++){
          this.messageDate_1 = this.textHistory[j].messageDate.split("T");
          this.textHistory[j].messageDate = this.messageDate_1[0];
          this.textHistory[j].messageTime = this.messageDate_1[1];
       }
       this.getUserText();
    },

    async getUserText() {
     //debugger
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetUserText";
      this.intDummyComm();
      this.dummyComm.visitId = this.propTarget.visitId;
      this.userTexts = await this.mixinsAxiosGetDataText(url, this.dummyComm);
    },

   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    //Email info
    getEmailInfor(messageShort, emailMessageShort, emailTo, subject) {
      this.GetUserImage();
      this.emailMessage = messageShort;
      this.emailMessageShort = emailMessageShort;
      this.emailTo = emailTo;
      this.subject = subject;
      $("#emailDetails").modal("show");
    },
    //For Image
    GetUserImage() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var UserId1 = arr[0];
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" +
        UserId1;
      this.axiosGetUserData11(url);
    },
    async axiosGetUserData11(Url) {
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          this.Image = res.data;
        })
        .catch(function (error) {
          alert(console.log(error));
        })
        .finally(() => {});
    },
    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
    paymentReceivedClick(what) {
      //alert(999)
      var valueAmount = String(this.aSinglePaymentReceived.amount);
      if (what == "cheque") {
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.ShowWarning("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.ShowWarning("Card Number length must be 16");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.ShowWarning("Holder name is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.ShowWarning("comment is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.ShowWarning("Card CVC is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.ShowWarning("Card CVC must be of 3 length");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.ShowWarning("Comment is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.ShowWarning("Zip is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.ShowWarning("Zip must be of 3 length");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.ShowWarning("Card Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.ShowWarning("Card Number length must be 16");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == "") {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      //this.aSinglePaymentReceived.visitId = this.aSinglePayment.visitId;
      //this.aSinglePaymentReceived.patientId = this.aSinglePayment.patientId;
      //this.aSinglePaymentReceived.pndx = this.aSinglePayment.pndx;
      this.intDummyComm();
      this.aSinglePaymentReceived.patientId = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Payments/SavPaymentReceived";
      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.loader_1();
      this.axiosGetData(url, myData, 106);
    },
    showCollectPaymentModel(pay) {
      // alert(pay.patientId);
      // console.log("KKKKKK: ", pay);
      this.aSinglePaymentReceived.amount = pay.amount;
      this.aSinglePaymentReceived.visitId = pay.visitId;
      $("#paymentMethodv2").modal("show");
    },
    deletePayment(pay) {
      console.log(pay.status, pay.oldStatus);
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Delete this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment";
          const myData = this.dummyComm;
          this.axiosGetData(url, myData, 105);
          this.successToastUpd();
          //this.showCollectPaymentModel();  DeletePayment
        }
      }); // swal
    },
    showReminderModel(pay) {
      this.aSinglePayment = JSON.parse(JSON.stringify(pay));
      $("#reminder").modal("show");
    },
    sendReminderClick() {
      if (this.aSinglePayment.phone.length == 0) {
        this.ShowWarning("Enter Phone number");
        event.preventDefault();
        return;
      } else if (this.aSinglePayment.phone.length < 12) {
        this.ShowWarning("Phone number length must be 10");
        event.preventDefault();
        return;
      } else if (this.aSinglePayment.email.length == 0) {
        this.ShowWarning("Enter Email");
        event.preventDefault();
        return;
      } else if (this.aSinglePayment.email.length > 0) {
        if (this.aSinglePayment.email != null) {
          if (!this.validEmail(this.aSinglePayment.email)) {
            this.Validity(this.e);
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePayment.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";
      const myData = { dc: this.dummyComm, pr: this.aSinglePayment };
      //const myData = this.dummyComm;
      this.axiosGetData(url, myData, 104);
    },
    requestPaymentClick() {
      if (this.initDatePR.length < 1) {
        this.endDatePR = new Date();
        this.startDatePR = new Date();
        this.startDatePR.setDate(this.startDatePR.getDate() - 60);
        this.initDatePR =
          this.dateToMDY(this.startDatePR) +
          " - " +
          this.dateToMDY(this.endDatePR);
      }
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDatePR);
      this.dummyComm.extras2 = this.dateToYMD(this.endDatePR);
      const url =
        this.SERVER + "/VNSPRAAPI/PatientComponent/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 103);
    },
    GetPatientInsurance() {
      this.intDummyComm();
      this.dummyComm.visitId = this.propTarget.visitId;
      this.dummyComm.patientId = this.propTarget.patientId;
      const url =
        this.SERVER + "/VNSPRAAPI/PatientComponent/GetPatientInsurance";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 102);
    },
    updateDetailsClickNew() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      } 
      // else if (this.aSinglePatient.phone == "") {
      //   this.ShowWarning("Phone is require");
      //   event.preventDefault();
      //   return;
      // } else if (this.aSinglePatient.address == "") {
      //   this.ShowWarning("Address is require");
      //   event.preventDefault();
      //   return;
      // } else if (this.aSinglePatient.city == "") {
      //   this.ShowWarning("City is require");
      //   event.preventDefault();
      //   return;
      // } else if (this.aSinglePatient.zip == "") {
      //   this.ShowWarning("Zip is require");
      //   event.preventDefault();
      //   return;
      // } else if (this.aSinglePatient.ssn == 0) {
      //   this.ShowWarning("Security number is require");
      //   event.preventDefault();
      //   return;
      // } else if (this.aSinglePatient.email == "") {
      //   this.ShowWarning("Email is require");
      //   event.preventDefault();
      //   return;
      // } 
      else if (this.isValidateDate(this.aSinglePatient.dob) == false) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      const dd = new Date(this.aSinglePatient.dob);
      const obj = {
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        patientId: this.aSinglePatient.patientId,
        externalId: this.aSinglePatient.externalId,
        ssn: this.aSinglePatient.ssn,
        email: this.aSinglePatient.email,
        phone: this.aSinglePatient.phone,
        streetAddress: this.aSinglePatient.streetAddress,
        city: this.aSinglePatient.city,
        state: this.aSinglePatient.state,
        zip: this.aSinglePatient.zip,
        gender: this.aSinglePatient.gender,
        dob: dd.toLocaleDateString(),
      };
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = 50;
     
      const url =
        this.SERVER + "/VNSPRAAPI/PatientComponent/SavePatientBasicInfo";
        const myData = {
        dc: this.dummyComm,
        patientInfo: obj,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };
      this.loader_1();
      this.axiosGetData(url, myData, 111);
    },
    fillPatientData(pat) {
      const dd = new Date(pat.dob);
      this.aSinglePatient.firstName = pat.firstName;
      this.aSinglePatient.lastName = pat.lastName;
      this.aSinglePatient.patientId = pat.patientId;
      this.aSinglePatient.externalId = pat.externalId;
      this.aSinglePatient.ssn = pat.ssn;
      this.aSinglePatient.email = pat.email;
      this.aSinglePatient.phone = pat.phone;
      this.aSinglePatient.streetAddress = pat.streetAddress;
      this.aSinglePatient.city = pat.city;
      this.aSinglePatient.state = pat.state;
      this.aSinglePatient.zip = pat.zip;
      this.aSinglePatient.gender = pat.gender;
      this.aSinglePatient.dob = this.dateToYMD(dd);
      //this.aSinglePatient.dobStr = this.dateToYMD(dd);
      //alert(this.aSinglePatient.dob);
    },
    getNewData() {
      this.intDummyComm();
      this.dummyComm.visitId = this.propTarget.visitId;
      this.dummyComm.patientId = this.propTarget.patientId;
      const url =
        this.SERVER + "/VNSPRAAPI/PatientComponent/GetPatientBasicData";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 100);
    },
    GetPatientQuest() {
      this.intDummyComm();
      this.dummyComm.visitId = this.propTarget.visitId;
      this.dummyComm.patientId = this.propTarget.patientId;
      const url = this.SERVER + "/VNSPRAAPI/PatientComponent/GetPatientQuest";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 101);
    },
    //-- OLD
    requestDeleteClick(pat) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text: "you want to delete this visit and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.patientId = pat.patientId;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DelPatientPortal";
          const myData = this.dummyComm;
          this.axiosGetData(url, myData, 24);
        }
      });
    },
    questOptionSelected(quest, opt) {
      quest.answer = opt.questOptionId;
    },
    demoSaveClick() {
      for (var j = 0; j < this.visitDemo.length; j++) {
        // if(this.visitDemo[j].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitDemo[j].questTypeName == "Phone Number") {
          if (this.visitDemo[j].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Date") {
          if (!this.isValidateDate(this.visitDemo[j].answer)) {
            this.ShowWarning("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Email") {
          if (this.visitDemo[j].answer != null) {
            if (!this.validEmail(this.visitDemo[j].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      //this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitDemo,
      };
      this.loader_1();
      this.axiosGetData(url, myData, 7);
    },
    collectPaymentButtonClass(rp) {
      if (rp.status == "4") return "btn btn-success";
      else return "btn btn-danger";
    },
    collectPaymentButtonClassDropDown(rp) {
      if (rp.status == "4")
        return "btn btn-success btn btn-success dropdown-toggle dropdown-toggle-split";
      else
        return "btn btn-success  btn btn-danger dropdown-toggle dropdown-toggle-split";
    },
    paymentReceivedClick_old(what) {
      // credit-card
      var valueAmount = String(this.aSinglePaymentReceived.amount);
      if (what == "cheque") {
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.ShowWarning("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.ShowWarning("Card Number length must be 16");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.ShowWarning("Holder name is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.ShowWarning("comment is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == 0) {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.ShowWarning("Card CVC is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.ShowWarning("Card CVC must be of 3 length");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.ShowWarning("Comment is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.ShowWarning("Zip is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.ShowWarning("Zip must be of 3 length");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.ShowWarning("Card Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.ShowWarning("Card Number length must be 16");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          event.preventDefault();
          return;
        }
        if (valueAmount == "") {
          this.ShowWarning("Amount is require");
          event.preventDefault();
          return;
        }
        if (valueAmount < 0) {
          this.ShowWarning("Invalid Amount");
          event.preventDefault();
          return;
        }
        if (
          valueAmount.indexOf(".") > -1 &&
          this.aSinglePaymentReceived.amount.split(".")[1].length > 2
        ) {
          this.ShowWarning("Amount allow with two decimal places");
          event.preventDefault();
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      //this.aSinglePaymentReceived.visitId = this.aSinglePatient.visitId;// not working ???
      this.aSinglePaymentReceived.patientId = this.aSinglePatient.patientId;
      this.aSinglePaymentReceived.pndx = this.aSinglePatient.pndx;
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
      const dd = new Date();
      this.dummyComm.myDate = dd.toLocaleDateString();
      this.dummyComm.extras =
        what +
        this.UKEY +
        dd.toLocaleDateString() +
        " " +
        dd.toLocaleTimeString();
      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.axiosGetData(url, myData, 12);
    },
    collectPaymentOptionsClick(what) {
      // this.intDummyComm();
      // const url = this.SERVER + "/VNSPRAAPI/Trackers/GetPayRecDat";
      // this.dummyComm.extras = this.mixinMakeCommString(
      //   this.aSinglePatient.visitId,
      //   what
      // ); //pat.visitId;
      // const myData = this.dummyComm;
      //this.axiosGetData(url, myData, 11);
      if (what == "credit-card") $("#debit").modal("show");
      else if (what == "cash") $("#cash").modal("show");
      else if (what == "cheque") $("#cheque").modal("show");
    },
    collectPayment(rp) {
      console.log("PPPP", rp);
      if (rp.status == 1) {
        this.ShowErrorAutoClose("Payment already made.");
        return;
      }
      this.aSinglePaymentReceived = {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: rp.visitId,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: rp.amount,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      };
      $("#paymentMethodv2").modal("show");
    },
    calcMainButtonClass(pat) {
      let xx = "btn btn-danger";
      if (pat.patientId > 0) {
        if (pat.isNew > 0) xx = "btn btn-warning";
        else xx = "btn btn-success";
      }
      return xx;
    },
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = new Date(start);
          self.endDatePR = new Date(end);
          self.initDatePR =
            self.dateToMDY(self.startDatePR) +
            " - " +
            self.dateToMDY(self.endDatePR);
        }
      );
    },
    datePicker() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate = new Date(start);
          self.endDate = new Date(end);
          self.initDate_1 =
            self.dateToMDY(self.startDate) +
            " - " +
            self.dateToMDY(self.endDate);
        }
      );
    },
    datePicker_1() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate_1 = new Date(start);
          self.endDate_1 = new Date(end);
          self.initDate_1 =
            self.dateToMDY(self.startDate_1) +
            " - " +
            self.dateToMDY(self.endDate_1);
        }
      );
    },
    datePicker_2() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDate_2 = new Date(start);
          self.endDate_2 = new Date(end);
          self.initDate_2 =
            self.dateToMDY(self.startDate_2) +
            " - " +
            self.dateToMDY(self.endDate_2);
        }
      );
    },
    GetAuditLog() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      //this.dummyComm.Extras = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData2";
      this.axiosGetData(url, this.dummyComm, 21);
    },
    GetTextHistory() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      const url = this.SERVER + "/VNSPRAAPI/PatientComponent/GetSmsHistory";
      this.axiosGetData(url, this.dummyComm, 201);
    },
    GetEmailHistory() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      const url = this.SERVER + "/VNSPRAAPI/PatientComponent/GetEmailHistory";
      this.axiosGetData(url, this.dummyComm, 202);
    },
    GetPaymentHistory() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      const url = this.SERVER + "/VNSPRAAPI/PatientComponent/GetPaymentHistory";
      this.axiosGetData(url, this.dummyComm, 203);
    },
    GetVisitHistory() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      this.dummyComm.filter = "";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/PatientComponent/GetVisitHistory";
      this.axiosGetData(url, this.dummyComm, 204);
    },
    saveInsuranceClick() {
      if (this.aSinglePatient.insurance.primaryInsurance == "") {
        this.ShowWarning("Primary insurance require");
        return;
      } else if (this.aSinglePatient.insurance.primaryInsuranceNo == "") {
        this.ShowWarning("Primary insurance No require");
        return;
      } else if (this.aSinglePatient.insurance.primaryInsuranceGroupId == "") {
        this.ShowWarning("Primary insurance GroupId require");
        return;
      } else if (this.aSinglePatient.insurance.secondaryInsurance == "") {
        this.ShowWarning("Secondary insurance require");
        return;
      } else if (this.aSinglePatient.insurance.secondaryInsuranceNo == "") {
        this.ShowWarning("Secondary insurance No require");
        return;
      } else if (
        this.aSinglePatient.insurance.secondaryInsuranceGroupId == ""
      ) {
        this.ShowWarning("Secondary insurance GroupId  require");
        return;
      }
      this.intDummyComm();
      let obj = {
        pndx: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
        primaryFilePath: "",
        secondaryFilePath: "",
      };
      //var firstfile = $("#customFileLang_f").val();
      var FirstFileName = $("#customFileLang_fl").html();
      // var secondfile = $("#customFileLang_s").val();
      var SecondFileName = $("#customFileLang_sl").html();
      obj = this.aSinglePatient.insurance;
      obj.fndx = this.aSinglePatient.pndx;
      obj.patientId = this.aSinglePatient.patientId;
      obj.primaryInsuranceId = FirstFileName;
      obj.secondaryInsuranceId = SecondFileName;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      obj.patientId = this.aSinglePatient.patientId;
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SaveInsurancePatient";
      const myData = {
        dc: this.dummyComm,
        Insurance: obj,
      };
      this.loader_1();
      this.axiosGetData(url, myData, 17);
    },
    getPatientInfo(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      var date = moment(String(this.aSinglePatient.dob)).format("YYYY-MM-DD");
      this.aSinglePatient.dob = date;
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);
    },
    showProfilePopup(pat, what) {
     //debugger
      //for Date
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 365);
      this.initDate_1 =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);
      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);
      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g,'');
      
      var date = moment(String(this.aSinglePatient.dob)).format("YYYY-MM-DD");
      this.aSinglePatient.dob = date;
      //   this.intDummyComm();
      //   let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      //   let myData = this.dummyComm;
      //   this.axiosGetData(url, myData, 15);
      $("#details_home").click();
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);
      if (what == "text") $("#textHistory1221").click();
      else if (what == "email") $("#emailtHistory1221").click();
      //$("#newptModal").modal("show");
    },
    searchMainList_1() {
      if (this.startDate != "" && this.endDate != "") {
        this.requestPaymentClick();
        // this.allFilterPatients_1 = this.requestPaymentsList.filter(
        //   (f) =>
        //     +new Date(f.dos) >= +new Date(this.startDate) &&
        //     +new Date(f.dos) <= +new Date(this.endDate)
        // );
      }
    },
    searchMainList_2() {
      //debugger; // eslint-disable-line no-debugger
      if (this.startDate_1 != "" && this.endDate_1 != "") {
        this.allFilterVisitHist = this.visitHistory.filter(
          (f) =>
            +new Date(f.dosLocalTime) >= +new Date(this.startDate_1) &&
            +new Date(f.dosLocalTime) <= +new Date(this.endDate_1)
        );
      }
    },
    searchMainList_3() {
      //-- keep
      if (this.startDate_2 != "" && this.endDate_2 != "") {
        this.allFilterPayHist = this.paymentHistory.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate_2) &&
            +new Date(f.dos) <= +new Date(this.endDate_2)
        );
      }
    },
    searchMainList() {
      if (this.mainSearch.searchExternalId !== "") {
        this.allFilterPatients = this.allRawPatients.filter((f) =>
          (f.externalId + " ").includes(this.mainSearch.searchExternalId)
        );
      } else {
        this.allFilterPatients = this.allRawPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.mainSearch.searchFirstName.toLowerCase()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.mainSearch.searchLastName.toLowerCase()) &&
            f.phone
              .toLowerCase()
              .startsWith(this.mainSearch.searchPhone.toLowerCase())
        );
      }
      if (this.mainSearch.searchDate !== "") {
        const dd = new Date(this.mainSearch.searchDate);
        this.allFilterPatients = this.allFilterPatients.filter(
          (f) => f.dob == dd.toLocaleDateString()
        );
      }
    },
    getIcon(id) {
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
    },
    dropDownButtonClick(pat) {
     //debugger
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 22);
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetAllPatients";
      this.axiosGetData(url, this.dummyComm, 1);
      this.StartLogoutTime();
    },
    //============================================================================
    async axiosGetData(myUrl, myData, what) {
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
      })
        .then((res) => {
          // if everything goes well -- we will get data
          //debugger; // eslint-disable-line no-debugger
          if (what === 1) {
            if (res.data.dc.auditFlag === 1) {
              this.allRawPatients = res.data.allPatients;
            }
          } else if (what === 4) {
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let i = 0; i < this.allPatients.length; i++) {
              const dd = new Date(this.allPatients[i].dob);
              this.allPatients[i].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients.filter(
              (f) =>
                f.firstName == obj.firstName ||
                f.lastName == obj.lastName ||
                f.ssn == obj.ssn ||
                f.phone == obj.phone ||
                f.email == obj.email
            );
            $("#mergeModal").modal("show");
          } else if (what === 12) {
            this.patients = res.data.patients;
            this.stageSteps = res.data.stageSteps.stages;
            this.insurance = res.data.insurance;
            this.requestPaymentClick();
            this.successToastUpd();
            $("#debit").modal("hide");
            $("#cash").modal("hide");
            $("#cheque").modal("hide");
          } else if (what === 14) {
            if (res.data.dc.auditFlag === 1) {
             //debugger
              //this.aSinglePatient = res.data.patient;
              this.visitQuests = res.data.quests.quests;
              this.visitDemo = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.paymentHistory = res.data.paymentHistory;
              //this.textHistory = res.data.textHistory;
              //this.userTexts = res.data.userTexts;
              this.emailHistory = res.data.emailHistory;
              this.visitHistory = res.data.visitHistory;
              var date = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );
              this.aSinglePatient.dob = date;
              if (res.data.insurances != null) {
                this.aSinglePatient.insurance = res.data.insurances;
                if (this.aSinglePatient.insurance.secondaryInsuranceId == "")
                  this.aSinglePatient.insurance.secondaryInsuranceId =
                    "Secondary Id";
                if (this.aSinglePatient.insurance.primaryInsuranceId == "")
                  this.aSinglePatient.insurance.primaryInsuranceId =
                    "Insurance Id";
              }
              this.users = res.data.users;
              $("#newptModal").modal("show");
              //this.successToastUpd();
            } else {
              this.ShowError(res.data.dc.auditFlagVal);
            }
            document.getElementById("customFileLang_f").value = "";
            document.getElementById("customFileLang_s").value = "";
            document.getElementById("customFileLang_sl").innerHTML =
              "Secondary Id";
          } else if (what === 22) {
            if (res.data.dc.auditFlag === 1) {
              this.visitQuests = res.data.quests.quests;
              this.visitDemo = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.paymentHistory = res.data.paymentHistory;
              //this.textHistory = res.data.textHistory;
              //this.userTexts = res.data.userTexts;
              this.emailHistory = res.data.emailHistory;
              this.visitHistory = res.data.visitHistory;
              var date1 = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );
              this.aSinglePatient.dob = date1;
              if (res.data.insurances != null) {
                this.aSinglePatient.insurance = res.data.insurances;
                if (this.aSinglePatient.insurance.secondaryInsuranceId == "")
                  this.aSinglePatient.insurance.secondaryInsuranceId =
                    "Secondary Id";
                if (this.aSinglePatient.insurance.primaryInsuranceId == "")
                  this.aSinglePatient.insurance.primaryInsuranceId =
                    "Insurance Id";
              }
              this.users = res.data.users;
            } else {
              this.ShowError(res.data.dc.auditFlagVal);
            }
            document.getElementById("customFileLang_f").value = "";
            document.getElementById("customFileLang_s").value = "";
            document.getElementById("customFileLang_sl").innerHTML =
              "Secondary Id";
          } else if (what == 7) {
            this.loader.hide();
            if (res.data.auditFlag == 1) {
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 17) {
            this.loader.hide();
            if (res.data.auditFlag === 1) {
              //document.getElementById("customFileLang_f").value = "";
              //document.getElementById("customFileLang_s").value = "";
              this.successToastUpd("Insurance saved successfully.");
              //this.allRawPatients = res.data.patients;
              //this.stagesSteps = res.data.stageSteps;
              //this.stageRes = res.data.stageRes;
              //this.stepRes = res.data.stepRes;
            }
          } else if (what === 15) {
            this.emailTempsList = res.data;
            this.emailTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
          } else if (what === 16) {
            // after saving patient information
            this.successToastUpd();
            if (res.data.dc.auditFlag === 1) {
              this.allRawPatients = res.data.allPatients;
            }
          } else if (what === 18) {
            if (res.data.dc.auditFlag > 0) {
              if (res.data.lpr.length < -991) {
                this.ShowErrorAutoClose("No Payment Request was made.");
                return;
              }
              this.requestPaymentsList = res.data.lpr;
            }
          } else if (what === 19) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Reminder Sent");
            } else {
              this.errorToastUpd(res.data.auditFlagVal);
            }
          } else if (what === 20) {
            this.loader.hide();
            if (res.data.auditFlag > 0) {
              this.showProfilePopup(this.aSinglePatient, "");
              this.successToastUpd("Email Sent");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 28) {
            this.smsTempsList = res.data;
            this.smsTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
            $("#sendText").modal("show");
          } else if (what === 26) {
            this.loader.hide();
            if (res.data.auditFlag > 0) {
              this.showProfilePopup(this.aSinglePatient, "");
              this.chatSms = "";
              this.successToastUpd("Text message sent");
              $("#sendText").modal("hide");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 27) {
            this.loader.hide();
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              this.getPatientInfo(this.aSinglePatient);
              this.chatSms = "";
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 24) {
            this.loader.hide();
            this.aSingleUserSmsHist = res.data;
            this.textHistorySerch = this.aSingleUserSmsHist;
            this.textHistory = [];
           for (let i=0;i<this.aSingleUserSmsHist.length;i++) {
             if(this.textHistorySerch[i].fromId == this.aSingleText.userId) {
            this.textHistory.push(this.textHistorySerch[i]);
          } 
        }
        for (let j=0;j<this.textHistory.length;j++) {
             this.messageDate_1 = this.textHistory[j].messageDate.split("T");
             this.textHistory[j].messageDate = this.messageDate_1[0];
              this.textHistory[j].messageTime = this.messageDate_1[1];
        }
      } else if (what === 25) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              $("#sendText").modal("hide");
            } else {
              this.ShowErrorAutoClose("Unable to Send Email");
            }
          } else if (what === 21) {
            this.auditData = res.data.visitHist;
          } else if (what === 23) {
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.allRawPatients = res.data.patients;
              this.stagesSteps = res.data.stageSteps;
              this.stepRes = res.data.stepRes;
              $("#mergeModal").modal("hide");
              $("#alertModal").modal("hide");
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 24) {
            if (res.data.dc.auditFlag > 0) {
              this.successToastUpd();
              this.loadInit();
            } else this.errorToast(res.data.dc.auditFlagVal);
          } else if (what === 100) {
            this.fillPatientData(res.data);
          } else if (what === 101) {
            this.visitDemo = res.data.quests;
          } else if (what === 111) {
            this.checkoutPatients = res.data.patients;
            this.loader.hide();
            // if (res.data.externalIdcount > 1) {
            //   this.ShowWarning("External ID must be Unique");
            //   event.preventDefault();
            //   return;
            // }
            this.successToastUpd();
            //this.loadInit();
            //location.reload();
          } else if (what === 102) {
            let obj = this.aSinglePatient.insurance;
            obj.primaryInsurance = res.data.primaryInsurance;
            obj.primaryInsuranceNo = res.data.primaryInsuranceNo;
            obj.primaryInsuranceGroupId = res.data.primaryInsuranceGroupId;
            obj.primaryInsuranceId = res.data.primaryInsuranceId;
            obj.secondaryInsurance = res.data.secondaryInsurance;
            obj.secondaryInsuranceNo = res.data.secondaryInsuranceNo;
            obj.secondaryInsuranceGroupId = res.data.secondaryInsuranceGroupId;
            obj.secondaryInsuranceId = res.data.secondaryInsuranceId;
            obj.primaryFilePath = res.data.primaryInsuranceId;
            obj.secondaryFilePath = res.data.secondaryInsuranceId;
          } else if (what === 103) {
            console.log("PR: ", res.data);
            this.requestPaymentsList = res.data.lpr;
          } else if (what === 104) {
            $("#reminder").modal("hide");
          } else if (what == 105) {
            this.requestPaymentsList = res.data;
          } else if (what === 106) {
            this.loader.hide();
            this.successToastUpd("Information updated");
            this.requestPaymentsList = res.data;
            $("#paymentMethodv2").modal("hide");
            $("#cheque").modal("hide");
            $("#cash").modal("hide");
            $("#debit").modal("hide");
            // if (res.status == 200) {
            //   this.successToastUpd("Information updated");
            //   this.requestPaymentsList = res.data;
            //   $("#paymentMethodv2").modal("hide");
            //   $("#cheque").modal("hide");
            //   $("#cash").modal("hide");
            //   $("#debit").modal("hide");
            // } else {
            //   this.errorToastUpd("Unable to complete request.");
            // }
          } else if (what === 201) {
            this.textHistory = res.data.textHistory;
            //this.userTexts = res.data.usersTexts;
          } else if (what === 202) {
            //debugger; // eslint-disable-line no-debugger
            this.emailHistory = res.data;
          } else if (what === 203) {
            this.paymentHistory = res.data;
          } else if (what === 204) {
            this.visitHistory = [];
            this.visitHistory = res.data;
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {this.ResetLogoutTime();});
    }, // axiosGetData
    // suggestedClick() {
    //   const obj = this.aSinglePatient;
    //   this.suggestedPatients = this.allPatients.filter(
    //     (f) =>
    //       f.firstName.toLowerCase() == obj.firstName.toLowerCase() ||
    //       f.lastName.toLowerCase() == obj.lastName.toLowerCase() ||
    //       f.ssn == obj.ssn ||
    //       f.phone == obj.phone ||
    //       f.email.toLowerCase() == obj.email.toLowerCase()
    //   );
    // },
    updateDetailsClick() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.phone == "") {
        this.ShowWarning("Phone is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.streetAddress == "") {
        this.ShowWarning("Address is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.city == "") {
        this.ShowWarning("City is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.zip == "") {
        this.ShowWarning("Zip is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.ssn == 0) {
        this.ShowWarning("Security number is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      } else if (this.isValidateDate(this.aSinglePatient.dob) == false) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email.length > 0) {
        if (this.aSinglePatient.email != null) {
          if (!this.validEmail(this.aSinglePatient.email)) {
            this.Validity(this.e);
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientPortalBasicInfo";
      const myData = {
        dc: this.dummyComm,
        patient: this.aSinglePatient,
      };
      this.axiosGetData(url, myData, 16);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    filterSearchList() {
      try {
        let dd = new Date(this.filterDate);
        let ds = dd.toLocaleDateString();
        if (dd == "Invalid Date" || dd.getFullYear() < 1900) {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone)
          );
        } else {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone) &&
              f.dob == ds
          );
        }
      } catch {
        this.suggestedPatients = this.allPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filterFirstName.toLowerCase()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filterLastName.toLowerCase()) &&
            f.phone.startsWith(this.filterPhone)
        );
      }
    },
    allPatientsClick() {
      this.filterFirstName = "";
      this.filterLastName = "";
      this.filterPhone = "";
      this.filterDate = "";
      this.filterDDate = "";
      this.filterSearchList();
    },
    mergeContinueClick() {
      Swal.fire({
        title: "Are you sure?",
        text: "After you merge these profiles. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Merge",
      }).then((result) => {
        if (result.value) {
          const dd = new Date();
          this.intDummyComm();
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          this.dummyComm.patientId = this.aSinglePatient.patientId;
          this.dummyComm.extras =
            this.aSelectedPatient.patientId +
            this.UKEY +
            dd.toLocaleDateString() +
            " " +
            dd.toLocaleTimeString();
          const url = this.SERVER + "/VNSPRAAPI/Trackers/MerPat";
          const myData = {
            dc: this.dummyComm,
            pat: this.aSinglePatient,
            ins: this.aSinglePatient.insurance,
          };
          this.axiosGetData(url, myData, 23);
        }
      });
    },
    mergeModalClick() {
      // if (this.aSinglePatient.patientId > 0) {
      //   this.ShowErrorAutoClose("User already Exit.");
      //   return;
      // }
      //this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPats";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 4);
    },
    alertModalClick_Suggested(pat) {
      this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      const obj = this.allInsurances.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      this.aSelectedInsurance = {
        primaryInsurance: "",
        primaryInsuranceId: "",
        primaryInsuranceGroupId: "",
        secondaryInsurance: "",
        secondaryInsuranceId: "",
        secondaryInsuranceGroupId: "",
      };
      if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].isPrimary == 1) {
            this.aSelectedInsurance.primaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.primaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.primaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          } else {
            this.aSelectedInsurance.secondaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.secondaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.secondaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          }
        }
      }
      $("#alertModal").modal("show");
    },
    paymentReminderClick() {
      if (this.aSinglePatient.phone.length == 0) {
        this.ShowWarning("Enter Phone number");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.phone.length < 12) {
        this.ShowWarning("Phone number length must be 10");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email.length == 0) {
        this.ShowWarning("Enter Email");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.email.length > 0) {
        if (this.aSinglePatient.email != null) {
          if (!this.validEmail(this.aSinglePatient.email)) {
            this.Validity(this.e);
          }
        }
      }
      this.aSinglePatient;
      this.aSingleRequestPayment;
      const Reminder = {
        patientId: this.aSingleRequestPayment.patientId,
        pndx: this.aSingleRequestPayment.pndx,
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        status: this.allFilterPatients_1[0].inputStatus,
        amount: this.aSingleRequestPayment.amount,
        phoneNo: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        dummy: this.dummyComm.extras,
      };
      const url = this.SERVER + "/VNSPRAAPI/Patient/ReminderEmailSms";
      const myData = {
        Reminder: Reminder,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, myData, 19);
    },
    GetPaymentInfo(rp) {
      this.aSingleRequestPayment = rp;
    },
    sendEmailClick() {
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 15);
    },
    selectedEmailTempClass(email) {
      if (email.emailTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleEmail.emailTemplateId == email.emailTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    emailTempsListClick(email) {
      this.aSingleEmail.emailTemplateId = email.emailTemplateId;
      if (email.emailTemplateId > 0)
        this.aSingleEmail = JSON.parse(JSON.stringify(email));
      else
        this.aSingleEmail = {
          name: "",
          emailTemplateId: 0,
          emailSubject: "",
          email: "",
          emailText: "",
        };
    },
    selectedEmailTempIcon(email) {
      if (email.emailTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },
    sendTextModalClose() {
      $("#sendText").modal("hide");
    },
    sendEmail() {
      if (this.aSingleEmail.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailSubject == "") {
        this.ShowWarning("Subject is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendEmail";
      const EmailData = {
        SentTo: this.aSinglePatient.email,
        SentFrom: "",
        Password: "",
        Body: this.aSingleEmail.emailText,
        Subject: this.aSingleEmail.emailSubject,
        TemplateName: this.aSingleEmail.name,
        UserId: this.dummyComm.ownerId,
        OwnerId: this.dummyComm.ownerId,
        PracticeId: this.dummyComm.practiceId,
        PatientId: this.aSinglePatient.patientId,
        VisitId: this.aSinglePatient.visitId,
        SentLocal: new Date(),
        //SentServer:
      };
      const myObject = {
        dc: this.dummyComm,
        email: EmailData,
      };
      this.loader_1();
      this.axiosGetData(url, myObject, 20);
    },
    sendTextClick() {
      if (this.smsTempsList.length <= 0) {
        this.intDummyComm();
        const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTxtTem";
        const myData = this.dummyComm;
        this.axiosGetData(url, myData, 28);
      } else $("#sendText").modal({ backdrop: "static", keyboard: false });
    },
    selectedSmsTempIcon(sms) {
      if (sms.smsTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },
    smsTempsListClick(sms) {
      this.selectedSmsId = sms.smsTemplateId;
      if (sms.smsTemplateId > 0)
        this.aSingleSms = JSON.parse(JSON.stringify(sms));
      else this.aSingleSms = { name: "", smsTemplateId: 0, smsText: "" };
    },
    selectedSmsTempClass(sms) {
      if (sms.smsTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.selectedSmsId == sms.smsTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    SendSms() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.aSingleSms.smsText,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: 0,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.loader_1();
      this.axiosGetData(url, myData, 26);
    },
    clickSmsLis(sms) {
       if (sms.userId === 0)
        return "list-group-item list-group-item-action btn-success";
       else {
        if (this.aSingleText.userId == sms.userId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    smsContactClick(User) {
       this.aSingleText.userId = User.userId;
       if (User.userId > 0)
        this.aSingleText = JSON.parse(JSON.stringify(User));
       else
         this.aSingleText = {
           userId: 0,
       };
      this.loader_1();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetUserSmsHist";
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.visitId;
      this.axiosGetData(url, this.dummyComm, 24);
    },
    chatSmsSent() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.chatSms,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: this.propTarget.visitId,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.loader_1();
      this.axiosGetData(url, myData, 27);
    },
  }, // methods
  watch: {
    "aSinglePatient.dobStr": function () {
      this.aSinglePatient.dob = this.aSinglePatient.dobStr;
    },
    "propTarget.visitId": function () {
      //if (this.propTarget.visitId > 0 && this.propTarget.patientId > 0)
      this.getNewData();
      document.getElementById("details_home").click();
    },
    "propTarget.patientId": function () {
      //if (this.propTarget.visitId > 0 && this.propTarget.patientId > 0)
      this.requestPaymentsList = "";
      this.getNewData();
      document.getElementById("details_home").click();
    },
    "propTarget.updButton": function () {
      this.updButton = this.propTarget.updButton;
      if (this.updButton == 0) {
        $("#a1").prop("disabled", true);
        $("#a2").prop("disabled", true);
        $("#a3").prop("disabled", true);
        $("#a4").prop("disabled", true);
        $("#a6").prop("disabled", true);
        this.collectPayButt = 0;
      }
    },
    //-- OLD
    requestPaymentsList: function () {
      try {
        for (let i = 0; i < this.requestPaymentsList.length; i++) {
          let dd = new Date(this.requestPaymentsList[i].dos);
          this.requestPaymentsList[i].dosDate = dd.toLocaleDateString();
          dd = new Date(this.requestPaymentsList[i].billDate);
          this.requestPaymentsList[i].billDateDate = dd.toLocaleDateString();
          this.requestPaymentsList[i].inputStatus =
            this.requestPaymentsList[i].status;
        }
      } catch {
        /**/
      } finally {
        //this.allFilterPatients_1 = this.requestPaymentsList;
        //this.searchMainList_1();
        //   this.$nextTick(() => {
        //   $("#paym").DataTable().destroy();
        //   $("#paym").DataTable({
        //       buttons: [
        //               'copy', 'csv', 'excel', 'pdf', 'print'
        //       ]
        //     });
        //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
        //   $(".paym").DataTable().draw();
        // });
      }
    },
    visitHistory: function () {
      try {
        for (let i = 0; i < this.visitHistory.length; i++) {
          let dd = new Date(this.visitHistory[i].dosLocalTime);
          this.visitHistory[i].dosLocalTime = dd.toLocaleDateString();
        }
      } catch {
        /**/
      } finally {
        this.allFilterVisitHist = this.visitHistory;
        this.searchMainList_2();
        this.$nextTick(() => {
          $("#visitm").DataTable().destroy();
          $("#visitm").DataTable({
            buttons: ["copy", "csv", "excel", "pdf", "print"],
          });
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $(".visitm").DataTable().draw();
        });
      }
    },
    paymentHistory: function () {
      this.allFilterPayHist = this.paymentHistory;
      this.searchMainList_3();
      this.$nextTick(() => {
        $("#config-table6").DataTable().destroy();
        $("#config-table6").DataTable({
          buttons: ["copy", "csv", "excel", "pdf", "print"],
        });
        $(
          ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
        ).addClass("btn btn-primary mr-1");
        $(".config-table6").DataTable().draw();
      });
    },
    allRawPatients: function () {
      try {
        for (let i = 0; i < this.allRawPatients.length; i++) {
          const dd = new Date(this.allRawPatients[i].dos);
          this.allRawPatients[i].dosdate = dd.toLocaleDateString();
          this.allRawPatients[i].dostime = dd.toLocaleTimeString();
          const ddd = new Date(this.allRawPatients[i].dob);
          this.allRawPatients[i].dob = ddd.toLocaleDateString();
        }
        //this.stageClick(0);
        //this.searchMainList();
      } catch {
        /**/
      } finally {
        /**/
        this.allFilterPatients = this.allRawPatients;
        this.searchMainList();
        this.$nextTick(() => {
          $("#home_2").DataTable().destroy();
          $("#home_2").DataTable({
            buttons: ["copy", "csv", "excel", "pdf", "print"],
          });
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $(".home_2").DataTable().draw();
        });
      }
    },
    "mainSearch.searchExternalId": function () {
      this.searchMainList();
    },
    "mainSearch.searchFirstName": function () {
      this.searchMainList();
    },
    "mainSearch.searchLastName": function () {
      this.searchMainList();
    },
    "mainSearch.searchPhone": function () {
      this.searchMainList();
    },
    "mainSearch.searchDate": function () {
      this.searchMainList();
    },
    startDate_1: function () {
      this.searchMainList_2();
    },
    endDate_1: function () {
      this.searchMainList_2();
    },
    startDate: function () {
      this.searchMainList_1();
    },
    endDate: function () {
      this.searchMainList_1();
    },
    initDate_1: function () {
      this.requestPaymentClick();
    },
    initDatePR: function () {
      this.requestPaymentClick();
    },
    startDate_2: function () {
      this.searchMainList_3();
    },
    endDate_2: function () {
      this.searchMainList_3();
    },
    filterFirstName: function () {
      this.filterSearchList();
    },
    filterLastName: function () {
      this.filterSearchList();
    },
    filterPhone: function () {
      this.filterSearchList();
    },
    filterDate: function () {
      // let dd = new Date(this.filterDate);
      // let ds = dd.toLocaleDateString();
      //   alert(dd);
      this.filterSearchList();
    },
  }, // watch:
  mounted() {
    this.emailHisUser = localStorage.getItem("UserName");
    this.endDatePR = new Date();
    this.startDatePR = new Date();
    this.startDatePR.setDate(this.startDatePR.getDate() - 60);
    this.initDatePR =
      this.dateToMDY(this.startDatePR) + " - " + this.dateToMDY(this.endDatePR);
  }, // mounted
  unmounted() {
        clearTimeout(this.TimerObject);
      },
};
</script>

<style scoped>
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* box-shadow: none; */
  width: 98%;
}
.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* box-shadow: none; */
  width: 98%;
}
.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* border-bottom: 2px solid rgb(240, 141, 11); */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1 {
  font-weight: bold;
  font-size: 15px;
  margin-left: -7px;
}
.label_select {
  margin-top: -23px;
  margin-left: 0px;
}

.activeColor {
  background-color: #fb9678;
  color: white;
}

.colorActive {
  color: #f95c2e;
}

.disabledColor {
  color: gray;
  background: lightgrey;
}

.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #00c292;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  height: 34px;
  width: 56px;
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

.label-color {
  color: black;
}

.asc-desc-btn {
  float: right;
}
#chat{
    margin-top: -67px;
    position: absolute;
    margin-left: 500px;
}
</style>